import axios from "axios";

const API = process.env.REACT_APP_API_BASE || "";

export const contactApi = {
  list: () => axios.get(`${API}/api/contact`),
  get: (id) => axios.get(`${API}/api/contact/${id}`),
  setRead: (id, isRead) => axios.patch(`${API}/api/contact/${id}/read`, { isRead }),
  remove: (id) => axios.delete(`${API}/api/contact/${id}`),
  create: (payload) => axios.post(`${API}/api/contact`, payload),
};
